module.exports = __webpack_public_path__ + "img/icon-17.939b7932.jpg";